import React from 'react';

const FallbackScreen: React.FC = () => <div>404</div>;

export default FallbackScreen;
